import React from 'react';
import { Box, Typography } from '@heycater/design-system';
import { useMediaQuery } from '@material-ui/core';
import { useRouter } from 'next/router';
import styled from 'styled-components';

import BackgroundImage from 'shared/components/BackgroundImage';
import IntlCitySelector from 'static_pages/marketing_pages/customer_landing_page/components/IntlCitySelector';
import { buildFunnelUrl } from 'static_pages/marketing_pages/helpers';

const FALLBACK_IMAGE = '/artifacts/images/marketing_pages/eating.webp';

function Hero({ title, subtitle, headerImage, titleBottom }) {
  const backgroundImage = headerImage?.fields?.file
    ? `https:${headerImage.fields?.file?.url}?w=1440`
    : FALLBACK_IMAGE;
  const mobile = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const router = useRouter();

  return (
    <StyledHero>
      <BackgroundImage
        priority
        src={backgroundImage}
        layout="fill"
        alt=""
        objectPosition="50% 50%"
        objectFit="cover"
      />
      <HeroContent>
        <Box mb={{ xs: 3, md: 4 }} mt={{ xs: 2, md: 5 }} color="#ffffff">
          <Typography variant="h1" mb={3}>
            {title} <br /> {titleBottom}
          </Typography>
          <Typography mb={2} variant={mobile ? 'subtitle2' : 'subtitle1'}>
            {subtitle}
          </Typography>
        </Box>
        <IntlCitySelector
          buttonLabelKey={'customerLandingPage.searchButton'}
          redirectURL={buildFunnelUrl({ router })}
        />
      </HeroContent>
    </StyledHero>
  );
}

const StyledHero = styled.div`
  background-repeat: no-repeat;
  background-color: rgba(48, 48, 48, 0.6);
  overflow: hidden;
  position: relative;
  text-align: center;

  ${(props) => props.theme.breakpoints.down('sm')} {
    padding: ${(props) => props.theme.spacing(5, 3, 0, 3)};
  }
`;

const HeroContent = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: ${(props) => props.theme.spacing(8, 10, 15, 10)};

  ${(props) => props.theme.breakpoints.down('sm')} {
    padding: ${(props) => props.theme.spacing(1, 2, 4, 2)};
  }
`;

export default Hero;
